import Axios from 'axios';
import { isDate, isValid, differenceInDays, parseISO, format } from 'date-fns';
import { isString } from 'util';
import { IColDef } from 'components/Material/Table/type';
import { IwarehouseList } from 'reducers/shareData/types';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import {
  Itrans,
  IdateFormat,
  IdAxios,
  IenqueueSnackbar,
  Ioption,
  IoptionTrans,
  Iobject,
  IsnackBarRsp,
} from './main_type.d';
import {
  getFindExpressNameByChkCode1AndWarehouse,
  getIsWarehouseExist,
  getfindEhuFunctionChk,
  getfindDropDownExpresssName,
  getfindDropDownContainerNo,
  getfindImctUserId,
  getfindSealNoInfo,
  getFindDropDown,
  postFindDropDown,
} from './main_api';
import {
  dDaFormat,
  dDaTiFormat,
  dDaTiFormatN,
  dDaTiFormatP,
  dDaFormatP,
  dTiFormatP,
  dTiFormat,
  dTi4FormatP,
  dTi4Format,
  colWidth,
  userTypeList,
} from './main_consts';

Axios.defaults.withCredentials = true;
const dAxios: IdAxios = async (
  method,
  url,
  enqueueSnackbar,
  data = {},
  config = {}
) => {
  // const consoleStr = `${sessionStorage.userUsingTask} ${url}`;
  try {
    let response;
    const methodL = method.toLowerCase();
    switch (methodL) {
      case 'get':
        response = await Axios[methodL](url, { params: data, ...config });
        break;

      case 'post':
      case 'put':
        response = await Axios[methodL](url, data, config);
        break;

      case 'delete':
        response = await Axios[methodL](url, { data, ...config });
        break;
      default:
        // TODO
        break;
    }
    return response;
  } catch (error) {
    if (enqueueSnackbar) {
      enqueueSnackbar('系統忙碌中，請稍後再試...');
    }
    return false;
  }
};

// data process ----------------------------------------------------------------
export const option2Trans = (options: Ioption[]): IoptionTrans => {
  const TransLabel: Itrans = {};
  const transOptions: Ioption[] = [];
  options.forEach((obj) => {
    TransLabel[obj.value] = obj.label;
    transOptions.push({
      value: obj.value,
      label: `${obj.label}(${obj.value})`,
    });
  });
  return [options, TransLabel, transOptions];
};

export const zeroFirst = (
  numValue: number | string,
  sliceNum: number
): string => `0000${numValue.toString()}`.slice(sliceNum);

export function daFormatTrans(
  value: string | Date | null,
  dateFormat: IdateFormat = dDaFormat
): string | Date | null {
  if (isDate(value) && isValid(value)) {
    const valueD = value as Date;
    const y = zeroFirst(valueD.getFullYear(), -4);
    const m = zeroFirst(valueD.getMonth() + 1, -2);
    const d = zeroFirst(valueD.getDate(), -2);
    const HH = zeroFirst(valueD.getHours(), -2);
    const mm = zeroFirst(valueD.getMinutes(), -2);
    const ss = zeroFirst(valueD.getSeconds(), -2);

    if (y && m && d && HH && mm && ss) {
      switch (dateFormat) {
        case dDaTiFormat:
          return `${y + m + d} ${HH}${mm}${ss}`;
        case dDaTiFormatN:
          return y + m + d + HH + mm + ss;
        case dDaTiFormatP:
          return `${y}/${m}/${d} ${HH}:${mm}:${ss}`;
        case 'yyyy/MM/dd HH:mm':
          return `${y}/${m}/${d} ${HH}:${mm}`;
        case dDaFormatP:
          return `${y}/${m}/${d}`;
        case dDaFormat:
          return y + m + d;
        case 'yyyy':
          return y;
        case 'yy':
          return y.substr(-2);
        case dTiFormatP:
          return `${HH}:${mm}:${ss}`;
        case dTiFormat:
          return HH + mm + ss;
        case dTi4FormatP:
          return `${HH}:${mm}`;
        case dTi4Format:
          return HH + mm;
        default:
          return null;
      }
    }
  } else if (isString(value) && value.length > 0) {
    let date = new Date();
    const y = Number(value.slice(0, 4));
    const m = Number(value.slice(5, 7)) - 1;
    const d = Number(value.slice(8, 10));
    const HH = Number(value.slice(-8, -6));
    const mm = Number(value.slice(-5, -3));
    const ss = Number(value.slice(-2));
    switch (dateFormat) {
      case dDaTiFormat:
      case dDaTiFormatN:
        date = new Date(
          y,
          Number(value.slice(4, 6)) - 1,
          Number(value.slice(6, 8)),
          Number(value.slice(-6, -4)),
          Number(value.slice(-4, -2)),
          ss
        );
        break;
      case dDaTiFormatP:
        date = new Date(y, m, d, HH, mm, ss);
        break;
      case 'yyyy/MM/dd HH:mm':
        date = new Date(y, m, d, HH, mm);
        break;
      case dDaFormatP:
        date = new Date(y, m, d);
        break;
      case dDaFormat:
        date = new Date(
          y,
          Number(value.slice(4, 6)) - 1,
          Number(value.slice(-2))
        );
        break;
      case dTiFormatP:
        date.setHours(HH);
        date.setMinutes(mm);
        date.setSeconds(ss);
        break;
      case dTiFormat:
        date.setHours(Number(value.slice(-6, -4)));
        date.setMinutes(Number(value.slice(-4, -2)));
        date.setSeconds(Number(value.slice(-2)));
        break;
      case dTi4FormatP:
        date.setHours(HH);
        date.setMinutes(mm);
        break;
      case dTi4Format:
        date.setHours(Number(value.slice(-4, -2)));
        date.setMinutes(Number(value.slice(-2)));
        break;
      default:
        break;
    }
    if (dateFormat.slice(0, 4) === 'YYYY') {
      date.setFullYear(y);
    }
    if (isValid(date)) {
      return date;
    }
  }
  return null;
}
export const getDateDayPlus = (
  plusDay = 0,
  nowDate: Date = new Date(),
  DateFormat: IdateFormat = dDaFormat
): string => {
  const localNowDate = new Date(nowDate.getTime());
  let plusDayTemp = plusDay;
  if (plusDay > 0) {
    plusDayTemp -= 1;
  } // 當天也算一天
  else if (plusDay < 0) {
    plusDayTemp += 1;
  }
  (localNowDate as Date).setDate(
    (localNowDate as Date).getDate() + plusDayTemp
  );
  return daFormatTrans(localNowDate, DateFormat) as string;
};

export const tiFormatTrans = (
  value: string | Date | null,
  dateFormat: IdateFormat = dTi4Format
): string | Date | null => daFormatTrans(value, dateFormat);
export const daTiFormatTrans = (
  value: string | Date | null,
  dateFormat: IdateFormat = dDaTiFormat
): string | Date | null => daFormatTrans(value, dateFormat);
// 1. check start < end
// 2. check interval
export const seDateVerify = (
  name: string,
  date: Date | null,
  seStr: [string, string],
  data: unknown,
  updateData: (x: Iobject) => void,
  enqueueSnackbar: IenqueueSnackbar,
  interval = 0,
  dateFormat = dDaFormat
): boolean => {
  const dataTemp = data as Iobject;
  const isStart = name === seStr[0];
  const isEnd = name === seStr[1];
  // maybe empty
  const startDate = isStart
    ? date
    : daFormatTrans(dataTemp[seStr[0]] as string, dateFormat);
  const endDate = isEnd
    ? date
    : daFormatTrans(dataTemp[seStr[1]] as string, dateFormat);

  if (!isDate(startDate) || !isDate(endDate)) {
    return false;
  }

  const startDateD = startDate as Date;
  const endDateD = endDate as Date;
  // check start < end
  if (startDateD > endDateD) {
    if (isStart) {
      updateData({
        [seStr[0]]: daFormatTrans(startDateD, dateFormat),
        [seStr[1]]: getDateDayPlus(interval, startDateD),
      });
    } else if (isEnd) {
      updateData({
        [seStr[0]]: getDateDayPlus(-interval, endDateD),
        [seStr[1]]: daFormatTrans(endDateD, dateFormat),
      });
    }
    enqueueSnackbar('起始日期不得大於結束日期。');
    return false;
  }

  // check interval
  if (interval && differenceInDays(endDateD, startDateD) > interval - 1) {
    if (isStart) {
      updateData({
        [seStr[0]]: daFormatTrans(startDateD, dateFormat),
        [seStr[1]]: getDateDayPlus(interval, startDateD),
      });
    } else if (isEnd) {
      updateData({
        [seStr[0]]: getDateDayPlus(-interval, endDateD),
        [seStr[1]]: daFormatTrans(endDateD, dateFormat),
      });
    }
    enqueueSnackbar(`日期間距不得大於${interval}日。`);
    return false;
  }
  return true;
};

// 日期起日不得小於三個月前
export const startDateAfterLast3monthVerify = (
  dataTemp: string,
  enqueueSnackbar: IenqueueSnackbar
): boolean => {
  const startDate = parseISO(dataTemp);

  if (!isDate(startDate)) {
    enqueueSnackbar(`日期起日格式錯誤。`);
    return false;
  }

  const startDateD = startDate as Date;
  const nowDateBeforeThreeMonth = parseISO(
    format(new Date().setMonth(new Date().getMonth() - 3), 'yyyyMMdd')
  );
  const nowDateBeforeThreeMonthD = nowDateBeforeThreeMonth as Date;

  if (differenceInDays(nowDateBeforeThreeMonthD, startDateD) > 0) {
    enqueueSnackbar(`日期起日不得小於三個月前。`);
    return false;
  }
  return true;
};

export const seDaTimeVerify = (
  name: string,
  date: Date | null,
  seStr: [[string, string], [string, string]],
  data: unknown,
  updateData: (x: Iobject) => void,
  enqueueSnackbar: IenqueueSnackbar,
  interval?: number,
  dateFormat = dDaFormat,
  timeFormat = dTi4Format
): boolean => {
  const dataTemp = data as Iobject;
  const dateStr = daFormatTrans(date, dateFormat);
  const isStart = name === seStr[0][0];
  const isEnd = name === seStr[1][0];
  const startStr = `${isStart ? dateStr : dataTemp[seStr[0][0]]} ${
    dataTemp[seStr[0][1]]
  }${timeFormat === dTi4Format ? '00' : ''}`;
  const endStr = `${isEnd ? dateStr : dataTemp[seStr[1][0]]} ${
    dataTemp[seStr[1][1]]
  }${timeFormat === dTi4Format ? '00' : ''}`;

  // maybe empty
  const startDate = daTiFormatTrans(startStr);
  const endDate = daTiFormatTrans(endStr);

  if (!isDate(startDate) || !isDate(endDate)) {
    return false;
  }

  const startDateD = startDate as Date;
  const endDateD = endDate as Date;
  // check start < end
  if (startDateD > endDateD) {
    if (isStart) {
      const startTiStr = tiFormatTrans(endDateD, timeFormat);
      updateData({
        [seStr[0][0]]: daFormatTrans(startDateD, dateFormat),
        [seStr[0][1]]:
          (!interval || interval === 0) &&
          (tiFormatTrans(dataTemp[seStr[0][1]] as string, timeFormat) as Date) >
            (tiFormatTrans(startTiStr, timeFormat) as Date)
            ? startTiStr
            : dataTemp[seStr[0][1]],
        [seStr[1][0]]: getDateDayPlus(interval, startDateD),
        // [seStr[0][0]]: daFormatTrans(endDateD, dateFormat),
        // [seStr[0][1]]:
        //   (tiFormatTrans(dataTemp[seStr[0][1]] as string, timeFormat) as Date) >
        //   (tiFormatTrans(startTiStr, timeFormat) as Date)
        //     ? startTiStr
        //     : dataTemp[seStr[0][1]],
      });
    } else if (isEnd) {
      const endTiStr = tiFormatTrans(startDateD, timeFormat);
      updateData({
        [seStr[1][0]]: daFormatTrans(startDateD, dateFormat),
        [seStr[1][1]]:
          (tiFormatTrans(endTiStr, timeFormat) as Date) >
          (tiFormatTrans(dataTemp[seStr[1][1]] as string, timeFormat) as Date)
            ? endTiStr
            : dataTemp[seStr[1][1]],
      });
    }
    enqueueSnackbar('起始日期不得大於結束日期。');
    return false;
  }

  // check interval
  if (interval && differenceInDays(endDateD, startDateD) > interval - 1) {
    if (isStart) {
      updateData({
        [seStr[0][0]]: daFormatTrans(startDateD, dateFormat),
        [seStr[1][0]]: getDateDayPlus(interval, startDateD),
      });
    } else if (isEnd) {
      updateData({
        [seStr[0][0]]: getDateDayPlus(-interval, endDateD),
        [seStr[1][0]]: daFormatTrans(endDateD, dateFormat),
      });
    }
    enqueueSnackbar(`日期間距不得大於${interval}日。`);
    return false;
  }
  return true;
};

// #region onchange -----------------------------------------------------------------------------------------

// DatePicker TimePicker DateTimePicker (material-ui/pickers)
export const datePickerChange =
  (updateData?: (x: Iobject) => void) =>
  (name: string, dateFormat: IdateFormat | string[] = dDaFormat) =>
  (date: Date | null): Iobject => {
    const updateObj: Iobject = {};
    updateObj[name] = daFormatTrans(date, dateFormat as IdateFormat);
    if (updateData) {
      updateData(updateObj);
    }
    return updateObj;
  };

export const dateTypingChange =
  (updateData?: (x: Iobject) => void) =>
  (name: string, dateFormat: IdateFormat | string[] = dDaFormat) =>
  (date: Date | null): Iobject => {
    const updateObj: Iobject = {};
    updateObj[`${name}Valid`] = isValid(date);
    if (isValid(date)) {
      updateObj[name] = daFormatTrans(date, dateFormat as IdateFormat);
    } else if (date === null) {
      updateObj[`${name}Valid`] = true;
      updateObj[name] = '';
    }

    if (updateData) {
      updateData(updateObj);
    }
    return updateObj;
  };

export const timePickerChange =
  (updateData?: (x: Iobject) => void) =>
  (name: string, dateFormat: IdateFormat | string[] = dTi4Format) =>
  (date: Date | null): Iobject =>
    datePickerChange(updateData)(name, dateFormat)(date);

export const timeTypingChange =
  (updateData?: (x: Iobject) => void) =>
  (name: string, dateFormat: IdateFormat | string[] = dTi4Format) =>
  (date: Date | null): Iobject =>
    dateTypingChange(updateData)(name, dateFormat)(date);

export const formatDateTime = (
  date: string,
  time: string,
  formatType = 'yyyy/MM/dd HH:mm:ss'
): string => {
  return format(parseISO(`${date} ${time}`), formatType);
};

export const formatDate = (date: string, formatType = 'yyyy/MM/dd'): string => {
  return format(parseISO(`${date}`), formatType);
};

export const isOverDayRange = (
  startDate: string,
  endDate: string,
  dayRange: number
): boolean => {
  const startDateD = daFormatTrans(startDate, dDaTiFormat) as Date;
  const endDateD = daFormatTrans(endDate, dDaTiFormat) as Date;
  if (differenceInDays(endDateD, startDateD) > dayRange - 1) {
    return true;
  }
  return false;
};

// StyleMultiline (material UI)
export const inputChange =
  (updateData?: (x: Iobject) => void) =>
  (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): Iobject => {
    const updateObj = {
      [e.target.name]: e.target.value,
    };
    if (updateData) {
      updateData(updateObj);
    }
    return updateObj;
  };

// StyleSelect (material UI)
export const selectChange =
  (updateData?: (x: Iobject) => void) =>
  (e: React.ChangeEvent<HTMLSelectElement>): Iobject => {
    const updateObj = {
      [e.target.name]: e.target.value,
    };
    if (updateData) {
      updateData(updateObj);
    }

    return updateObj;
  };

// FormControlGen (material UI)
export const radioChange =
  (updateData?: (x: Iobject) => void) =>
  (e: React.ChangeEvent<HTMLInputElement>, value: string): Iobject => {
    const updateObj = { [e.target.name]: value };
    if (updateData) {
      updateData(updateObj);
    }
    return updateObj;
  };

// Checkbox (material UI)
export const checkboxChange =
  (updateData?: (x: Iobject) => void) =>
  (TrueVal: [string | boolean, string | boolean]) =>
  (e: React.ChangeEvent<HTMLInputElement>): Iobject => {
    const updateObj = {
      [e.target.name]: e.target.checked ? TrueVal[0] : TrueVal[1],
    };
    if (updateData) {
      updateData(updateObj);
    }
    return updateObj;
  };
// #endregion

let timer: NodeJS.Timeout;
export const timerDebounce = (func: () => void, delay = 500): void => {
  if (timer) {
    clearInterval(timer);
  }
  timer = setTimeout(func, delay);
};

// #region 快遞倉站、記帳代號
export const getExpressName = async (
  updateObj: Iobject,
  master: Iobject
): Promise<{ text: string; error: boolean }> => {
  const masterTemp = { ...master, ...updateObj };
  const { chkCode1, warehouse } = masterTemp;

  const result = await getFindExpressNameByChkCode1AndWarehouse({
    chkCode1,
    warehouse,
  });
  if (result.data.status === 0) {
    return { text: result.data.data as string, error: false };
  }
  return { text: result.data.msg as string, error: true };
};

export const getWarehouse = async (
  updateObj: Iobject,
  master: Iobject
): Promise<{ text: string; error: boolean }> => {
  const masterTemp = { ...master, ...updateObj };
  const { warehouse } = masterTemp;
  const result = await getIsWarehouseExist({
    warehouse,
  });
  if (result.data.status === 0) {
    return { text: result.data.data as string, error: false };
  }
  return { text: result.data.msg as string, error: true };
};

const getExpressStatus = async (
  chkCode1: string,
  warehouse: string
): Promise<{ msg: string; status: string }> => {
  const result = await getFindExpressNameByChkCode1AndWarehouse({
    chkCode1,
    warehouse,
  });
  const { data, msg, status } = result.data;
  if (status === 0) {
    return { msg: String(data), status: String(status) };
  }
  return { msg, status: String(status) };
};

const getWarehouseStatus = async (
  warehouse: string
): Promise<{ msg: string; status: string }> => {
  const result = await getIsWarehouseExist({
    warehouse,
  });
  const { data, msg, status } = result.data;
  if (status === 0) {
    return { msg: String(data), status: String(status) };
  }
  return { msg, status: String(status) };
};

interface IcheckWarehouseAndChkCode2Result {
  expressMsg: string;
  warehouseMsg: string;
  expressStatus: string;
  warehouseStatus: string;
}

export const checkWarehouseAndChkCode2 = async (
  chkCode1: string,
  warehouse: string
): Promise<IcheckWarehouseAndChkCode2Result> => {
  const data = {
    expressMsg: '',
    warehouseMsg: '',
    expressStatus: '',
    warehouseStatus: '',
  };
  if (chkCode1.length > 0) {
    const { msg, status } = await getExpressStatus(chkCode1, warehouse);
    data.expressMsg = msg;
    data.expressStatus = status;
  }
  if (warehouse.length > 0) {
    const { msg, status } = await getWarehouseStatus(warehouse);
    data.warehouseMsg = msg;
    data.warehouseStatus = status;
  }

  return data;
};

export interface EhuFunctionChkResult {
  aspUserId: string;
  userName: string;
  usertype: string;
  locationCode: string;
  boxNo: string;
  ban: string;
  asType: string;
  chkCode1: string;
  chkCode2: string;
  chkCode3: string;
  userId: string;
  updTime: string;
  roleType: string;
  sender_id: string;
  uvFlag: string;
  boxno1: string;
}

export const getEhuFunctionChk = async (): Promise<EhuFunctionChkResult> => {
  const data = {
    aspUserId: '',
    userName: '',
    usertype: '',
    locationCode: '',
    boxNo: '',
    ban: '',
    asType: '',
    chkCode1: '',
    chkCode2: '',
    chkCode3: '',
    userId: '',
    updTime: '',
    roleType: '',
    sender_id: '',
    uvFlag: '',
    boxno1: '',
  };
  const result = await getfindEhuFunctionChk();

  return result.data.data as EhuFunctionChkResult;
};

// #endregion

export interface IDropDownOpenList {
  dropDownId: string;
  dropDownDesc: string;
}
export const getFindDropDownList = async (
  funcName: string,
  para = {}
): Promise<Ioption[]> => {
  const result = await getFindDropDown('common', funcName, para);

  const tmpData = result.data.data as IDropDownOpenList[];

  const list: Ioption[] = [];

  tmpData.forEach((item) => {
    list.push({
      value: item.dropDownId as string,
      label: item.dropDownDesc as string,
    });
  });
  return list;
};

export const getFindDropDownOneList = async (
  apiName: string,
  funcName: string,
  enqueueSnackbar: IenqueueSnackbar,
  para = {}
): Promise<string[]> => {
  const result = await getFindDropDown(apiName, funcName, para);

  const tmpData = result.data.data as string[];

  if (result && result.data.status !== 0) {
    enqueueSnackbar(result.data.msg);
  }

  return tmpData;
};

// #region 快遞業者/承攬業者下拉選單

export const postFindDropDownOneList = async (
  apiName: string,
  funcName: string,
  enqueueSnackbar: IenqueueSnackbar,
  para = {}
): Promise<string[]> => {
  const result = await postFindDropDown(apiName, funcName, para);

  const tmpData = result.data.data as string[];

  if (result && result.data.status !== 0) {
    enqueueSnackbar(result.data.msg);
  }

  return tmpData || [''];
};

export interface DropDownExpresssName {
  expresssName: string;
}
export const getfindDropDownExpresssNameList = async (
  startUploadDate: string,
  endUploadDate: string,
  warehouse: string
): Promise<DropDownExpresssName[]> => {
  const result = await getfindDropDownExpresssName({
    startUploadDate,
    endUploadDate,
    warehouse,
  });

  return result.data.data as DropDownExpresssName[];
};

// #endregion

// #region 動態櫃號下拉選單

export interface DropDownContainerNo {
  containerNo: string;
}
export const getfindDropDownContainerNoList = async (
  declDate: string,
  warehouse: string,
  vesselRegNo: string
): Promise<string[]> => {
  const result = await getfindDropDownContainerNo({
    declDate,
    warehouse,
    vesselRegNo,
  });
  const listDropDownContainerNo = result.data.data as DropDownContainerNo[];
  const list: string[] = [];
  listDropDownContainerNo.map((item) => list.push(item.containerNo));

  return list;
};

// #endregion

// #region 櫃動庫登錄帳號

export const getfindImctUserIdlist = async (
  warehouse: string
): Promise<string> => {
  const result = await getfindImctUserId({
    warehouse,
  });

  return result.data.data as string[0];
};

// #endregion

// #region 取得封條號碼

export const getfindSealNoInfolist = async (
  declDate: string,
  warehouse: string,
  containerNo: string,
  vesselRegNo: string
): Promise<string> => {
  const result = await getfindSealNoInfo({
    declDate,
    warehouse,
    containerNo,
    vesselRegNo,
  });

  return result.data.data as string[0];
};

// #endregion

// #region 取得TABLE 欄位寬度
export const getColWidthByField = (colDefList: IColDef[]): IColDef[] =>
  colDefList.map((obj) =>
    colWidth[obj.field]
      ? {
          ...obj,
          width: colWidth[obj.field],
        }
      : obj
  );

// #endregion

// #region 設定預設儲區資料
export function initWhrehhouse(
  userType: string,
  warehouseRedux: IwarehouseList[],
  locationCode: string
): string {
  if (
    userType === userTypeList.type1[0] ||
    userType === userTypeList.type6[0]
  ) {
    return locationCode;
  }
  if (userType === userTypeList.type2[0]) {
    return warehouseRedux.length > 0 ? warehouseRedux[0].locationCode : '';
  }
  return '';
}
// #endregion

export default dAxios;
